import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { Project } from "shared/types/Project"
import { WithClassName } from "shared/types/WithClassName"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"
import { TextHighlighter } from "shared/ui/text-highlighter/TextHighlighter"

import "./styles/_project-title.scss"

export interface ProjectTitleProps extends WithClassName {
  project:
    | Pick<Project, "title" | "team" | "hasClarificationRequest">
    | null
    | undefined
  showClarificationRequestIndicator?: boolean
  ranges?: number[]
}

export const ProjectTitle = React.memo(
  ({
    className,
    project,
    showClarificationRequestIndicator,
    ranges
  }: ProjectTitleProps) => {
    const { t } = useTranslation()

    if (!project) {
      return null
    }

    const { title, team, hasClarificationRequest } = project

    return (
      <div className={classNames("project-title", className)}>
        <span className="project-title__text">
          <TextHighlighter text={title || ""} ranges={ranges} />
        </span>
        {team?.id ? (
          <div className="project-title__team-indicator">
            <span className="visually-hidden">
              {t("Project.TeamIndicator")}
            </span>
            <Icon name={IconName.TEAM} />
          </div>
        ) : null}
        {showClarificationRequestIndicator && hasClarificationRequest ? (
          <div className="project-title__cr-indicator">
            <span className="visually-hidden">
              {t("ClarificationRequest.Indicator")}
            </span>
            <Icon name={IconName.CLARIFICATION_REQUEST} />
          </div>
        ) : null}
      </div>
    )
  }
)
